"use strict";
// Copyright (c) StrangeBee 2023
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
class ReportTemplateController extends __1.ParentController {
    constructor() {
        super(...arguments);
        this.endpoints = {
            create: '/v1/caseReportTemplate',
            import: '/v1/caseReportTemplate/import',
            export: '/v1/caseReportTemplate/:caseReportTemplateId/export',
            edit: '/v1/caseReportTemplate/:objectId',
            delete: '/v1/caseReportTemplate/:objectId',
            get: '/v1/caseReportTemplate/:objectId',
            addAttachment: '/v1/caseReportTemplate/:caseReportTemplateId/attachment',
            getAttachment: '/v1/caseReportTemplate/:caseReportTemplateId/attachment/:attachmentId',
            getFieldsList: '/v1/caseReportTemplate/_info',
        };
    }
    import(reportTemplate) {
        return this.manager.post({
            url: this.endpoints.import,
        }, reportTemplate);
    }
    export(reportTemplateId) {
        return this.manager.post({
            url: this.endpoints.export,
            params: { reportTemplateId },
        });
    }
    addAttachment(caseReportTemplateId, formData) {
        return this.manager.post({ url: this.endpoints.addAttachment, params: { caseReportTemplateId } }, formData);
    }
    getAttachment(caseReportTemplateId, attachmentId) {
        return this.manager.get({ url: this.endpoints.getAttachment, params: { caseReportTemplateId, attachmentId } }, { responseType: 'arraybuffer' });
    }
    getFieldsList() {
        return this.manager.get({ url: this.endpoints.getFieldsList });
    }
}
exports.default = ReportTemplateController;
